import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/Mobilelayout/admin-dashboard";
import CategoryAttachmentList from "../screens/MobileInfoAttachment/CategoryAttachmentList";

const breadCrumbData = [{ link: "/category-info-attachment-list", name: "Document Search" }];
const CategoryManagement = () => (
  <>
    <LayoutContainer>
      {/* <BreadCrumb data={breadCrumbData} /> */}
      <CategoryAttachmentList />
    </LayoutContainer>
  </>
);

export default CategoryManagement;